import { motion } from "framer-motion";
import { IMAGES } from "../lib/config";
import { Instagram, Mic } from "lucide-react";

export default function Speaker() {
  return (
    <section className="relative bg-white py-24 lg:py-32 px-6 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative"
        >
          <div className="relative aspect-[4/5] overflow-hidden rounded-2xl bg-gradient-to-br from-yellow-400 to-orange-600 p-1">
            <img
              src={IMAGES.speaker}
              alt="Pastor Cristian Rosario"
              className="w-full h-full object-cover rounded-xl"
              data-testid="speaker-image"
            />
          </div>
          {/* Decorative element */}
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-yellow-400 -z-10 rounded-2xl" />
          <div className="absolute -top-6 -left-6 w-24 h-24 border-4 border-orange-500 -z-10 rounded-2xl" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-black text-yellow-400 text-xs uppercase tracking-[0.4em] font-bold mb-6">
            <Mic className="w-3 h-3" />
            Exponente de la Palabra
          </div>
          <h2 className="font-heading uppercase text-5xl sm:text-7xl lg:text-8xl text-black leading-[0.9] tracking-tighter">
            Pastor<br />
            <span className="text-orange-600">Cristian</span><br />
            <span className="text-gradient-gold">Rosario</span>
          </h2>
          <p className="mt-8 text-lg text-gray-700 leading-relaxed max-w-lg">
            Un mensajero apasionado por la juventud. Sus palabras han impactado a miles de jóvenes 
            con un evangelio relevante, profundo y lleno de poder. Prepárate para escuchar la palabra 
            que rescatará tu vida.
          </p>
          <a
            href="https://instagram.com/RestorationChurchNY"
            target="_blank"
            rel="noreferrer"
            data-testid="speaker-instagram-link"
            className="inline-flex items-center gap-2 mt-6 px-6 py-3 bg-gradient-to-r from-pink-500 to-purple-600 text-white font-semibold rounded-full hover:scale-105 transition-transform"
          >
            <Instagram className="w-5 h-5" />
            @RestorationChurchNY
          </a>
        </motion.div>
      </div>
    </section>
  );
}
